import {Component, Injectable, ElementRef, OnInit,AfterContentInit, Attribute, Renderer2, AfterViewInit,Input, AfterContentChecked, Inject} from '@angular/core';
import {AbsTablesComponent} from './abs-tables.component';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
    selector: '[abs-responsive-row]',
    template: `<td class="column1" [ngClass]="{'faux-table-cell': isSummary}" *ngIf="responsive" scope="row" role="rowheader"  id="{{headersId}}" [attr.aria-labelledby]="headerName">  
    <span *ngIf="!isSummary" [attr.aria-hidden]="!active" [hidden]="!active">{{columnData}} </span>
    <button [attr.aria-describedby]="'sup-actNum'+id" [attr.aria-expanded]="expandFlag" [hidden]="active" (click)="toggleExpandFlag()">
        <i [ngClass]="{'icon-collapsed': !expandFlag, 'icon-expanded': expandFlag}" [attr.aria-hidden]="true"></i>
        <span class="cell-button-text" [innerHTML]="columnData"></span> 
    </button>
    <span aria-hidden="true" id="sup-actNum{{id}}" style="display:none">{{expandFlag && "Hide row below."|| "Show row below."}}</span>
</td>
<ng-content></ng-content>
<tr class="data-row-list" *ngIf="!isSummary && responsive">
    <td colspan="9" headers="heading1 rowheader_t2_0">
        <div [attr.aria-expanded]="expandFlag" [@expand]="expandFlag ? 'open' : 'close'">
            <ul class="bullet" >
                <li *ngFor="let headerValue of headerValues;let index=index" class="ng-scope">
                    <div [ngClass]="headerClass[$index]">{{headerValue}}</div>
                    <div [ngClass]="bodyClass[$index]" >{{rowValues[index]}}</div>
                </li>
            </ul>
        </div>
    </td>
</tr>
<tr class="data-row-list accordion-content"  *ngIf="isSummary && responsive">
	<td>
		<div [attr.aria-expanded]="expandFlag" [@expand]="expandFlag ? 'open' : 'close'" abs-append-element="summaryContent"></div>
	</td>
</tr>`,
    animations: [
        trigger('expand', [
            state('close', style({
                opacity: 0,
                display: 'none',
                height: 0
            })),
            state('open', style({
                display: 'block',
                opacity: 1
            })),
            transition('close => open', animate('0.3s ease-in-out')),
            transition('open => close', animate('0.3s ease-in-out'))
        ])]
})
@Injectable()
export class AbsResponsiveRowComponent implements AfterContentInit, AfterContentChecked, AfterViewInit, OnInit {
     headerValues = [];
    @Input('isSummary')  isSummary;
    @Input('responsive')  responsive: any;
    @Input('headersId')  headersId: any;
    @Input('headerName')  headerName: any;
    @Input('tabledata')  tabledata;
    @Input('rowData')  rowData;
    @Input('id')  id: any;
    @Input('expand')  expand: any;
     rowValues: any = [];
     headerClass: any = {};
     bodyClass: any = {};
     active = false;
     expandFlag = false;
     rowElement;
     parentRowElement: any;
     summaryContent;
     columnData: any;
     summaryArray = [];
     previousHidden = 0;

    constructor(
        @Inject(ElementRef) private el: ElementRef, 
        @Inject(Renderer2) private renderer: Renderer2,
        @Inject(AbsTablesComponent) private comp: AbsTablesComponent,
    ) {
    }
    ngOnInit() {
        this.comp.rowNumber++;
        if (this.comp.rowNumber === this.expand) {
            this.toggleExpandFlag(true);
        }
    }
    ngAfterContentInit() {
        if (this.rowData !== undefined) {
            if (typeof (this.rowData) === 'string') {
                this.columnData = this.rowData;
            } else {
                this.columnData = this.rowData[Object.keys(this.rowData)[0]];
            }
        }

    }
    ngAfterViewInit() {
        this.rowElement = this.el.nativeElement.parentElement.querySelectorAll('[abs-responsive-row]');
        if (this.responsive && this.comp.headers !== undefined) {
            this.parentRowElement = this.el.nativeElement;
            const rowListElement = this.el.nativeElement.querySelector('.data-row-list');
            this.el.nativeElement.insertAdjacentElement('afterEnd', rowListElement);
        }

        if (this.isSummary) {
            if (this.rowData !== undefined && typeof (this.rowData) !== 'string') {
                for (let i = 0; i < (Object.keys(this.rowData).length); i++) {
                    this.summaryArray.push(this.rowData[i]);
                    this.renderer.setProperty(this.el.nativeElement.children[1],'innerHTML',this.summaryArray[1]);
                    this.renderer.addClass(this.el.nativeElement.children[1], 'faux-table-cell');
                    if (this.rowData[i] === '') {
                        this.renderer.removeChild(this.el.nativeElement.children[0],this.el.nativeElement.children[0].children[0]);
                        this.renderer.addClass(this.el.nativeElement, 'inactive-table-header');
                        this.el.nativeElement.children[0].insertAdjacentHTML('beforeend', this.summaryArray[0]);
                    }

                }
            } else if (this.rowData !== undefined && (typeof (this.rowData) === 'string')) {
                this.renderer.addClass(this.el.nativeElement.children[1], 'faux-table-cell');
            } else {
                this.renderer.addClass(this.el.nativeElement, 'inactive-table-header');
                for (let i = 0; i < this.el.nativeElement.children.length; i++) {
                    this.renderer.addClass(this.el.nativeElement.children[i], 'faux-table-cell');
                }
            }
        }
    }

    ngAfterContentChecked() {
        if (this.comp.hiddenColumn.length !== 0 && this.previousHidden !== this.comp.hiddenColumn.length) {
            this.headerValues = [];
            this.rowValues = [];
            for (let j = 0; j < this.comp.hiddenColumn.length; j++) {
                if (this.comp.headers[this.comp.hiddenColumn[j]] !== undefined) {
                    this.headerValues.push(this.comp.headers[this.comp.hiddenColumn[j]].innerText);
                    this.rowValues.push(this.comp.rowValue[this.comp.hiddenColumn[j]].innerText);
                }
                this.previousHidden = this.comp.hiddenColumn.length
            }
        }
    }
     setSummaryContentValue(contentValue) {
        this.summaryContent = contentValue;
        if (this.summaryContent !== null) {
            let ref = this.el.nativeElement.querySelector('[abs-append-element]')
            ref.insertAdjacentHTML('beforeend', this.summaryContent);
            return
        }
    };
     toggleExpandFlag(expandFlag) {
        let content = this.el.nativeElement;
        if (this.isSummary === false) {
            if ((expandFlag) !== undefined) {
                this.expandFlag = expandFlag;
            } else {
                this.expandFlag = !this.expandFlag;
            }
            if (this.rowElement !== undefined) {
                if (this.expandFlag) {
                    this.renderer.addClass(this.parentRowElement, 'opened');
                } else {
                    this.renderer.removeClass(this.parentRowElement, 'opened');
                }
            }
        } else {
            if ((expandFlag) !== undefined) {
                this.expandFlag = expandFlag;
            } else {
                this.expandFlag = !this.expandFlag;
                if (this.rowElement !== undefined) {
                    for (var i = 0; i < this.rowElement.length; i++) {
                        if (this.expandFlag) {
                            this.renderer.addClass(this.parentRowElement, 'opened');
                            this.calculateTableCellLines();
                            content.setAttribute('tabindex', '0');
                            setTimeout(() => {
                                content.focus();
                            }, 100);
                        } else {
                            this.renderer.removeClass(this.parentRowElement, 'opened');
                            content.setAttribute('tabindex', '-1');
                        }
                    }
                }
            }

        }
    }
     calculateTableCellLines() {
        setTimeout(() => {
            const fauxTableCell = this.el.nativeElement.parentElement.querySelectorAll('.accordion-content .faux-table-cell');
            for (let i = 0; i < fauxTableCell.length; i++) {
                let cellHeight = fauxTableCell[i].clientHeight - 17;
                fauxTableCell[i].style.backgroundPosition = '0px ' + cellHeight + 'px';
            }
        }, 50);
    }
}


